import { BaseContainerModel } from "../../../base-container.model";
import { bl_alg_cc_project_settlement_method_link_RowClass } from "../../../../dbschema";

export class ProjectSettlementMethodLinkContainerModel extends BaseContainerModel {
  bl_alg_cc_project_settlement_method_link: bl_alg_cc_project_settlement_method_link_RowClass = new bl_alg_cc_project_settlement_method_link_RowClass();
}
